var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 40,
    fill: "#0D0D0D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 220,
    height: 40,
    fill: "#0D0D0D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 140,
    height: 40,
    fill: "#0D0D0D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 320,
    width: 120,
    height: 40,
    fill: "#0D0D0D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 360,
    width: 120,
    height: 40,
    transform: "rotate(-90 240 360)",
    fill: "#0D0D0D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 240,
    width: 60,
    height: 40,
    fill: "#0D0D0D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 360,
    width: 60,
    height: 40,
    transform: "rotate(-90 320 360)",
    fill: "#0D0D0D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 440,
    width: 140,
    height: 40,
    transform: "rotate(-90 400 440)",
    fill: "#0D0D0D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 520,
    width: 220,
    height: 40,
    transform: "rotate(-90 480 520)",
    fill: "#0D0D0D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 600,
    width: 300,
    height: 40,
    transform: "rotate(-90 560 600)",
    fill: "#0D0D0D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 560,
    width: 600,
    height: 40,
    fill: "#0D0D0D"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 600,
    width: 600,
    height: 40,
    transform: "rotate(-90 0 600)",
    fill: "#0D0D0D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 520,
    width: 440,
    height: 40,
    transform: "rotate(-90 80 520)",
    fill: "#0D0D0D"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 440,
    width: 280,
    height: 40,
    transform: "rotate(-90 160 440)",
    fill: "#0D0D0D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 400,
    width: 280,
    height: 40,
    fill: "#0D0D0D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 480,
    width: 440,
    height: 40,
    fill: "#0D0D0D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 40,
    width: 180,
    height: 40,
    fill: "#0D0D0D"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 240,
    width: 200,
    height: 80,
    transform: "rotate(-90 340 240)",
    fill: "#0D0D0D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 260,
    width: 180,
    height: 40,
    transform: "rotate(-90 520 260)",
    fill: "#0D0D0D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 260,
    width: 180,
    height: 40,
    transform: "rotate(-90 520 260)",
    fill: "#0D0D0D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 260,
    width: 180,
    height: 40,
    transform: "rotate(-90 520 260)",
    fill: "#0D0D0D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 180,
    width: 180,
    height: 80,
    fill: "#0D0D0D"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 163,
    width: 20,
    height: 20,
    fill: "#0D0D0D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 80,
    width: 40,
    height: 40,
    fill: "#0D0D0D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ae1b6a4e67b00550a56df0b7fefe096.svg";
export { ForwardRef as ReactComponent };